module.exports = __webpack_public_path__ + "static/media/InnerBox_Search.edbc6f82.svg";